var _g, _circle, _g2, _g3, _rect, _circle2, _rect2, _rect3, _g4, _g5, _mask, _path, _path2, _mask2, _path3, _path4, _mask3, _path5, _path6, _mask4, _path7, _path8, _mask5, _path9, _path10, _mask6, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 587,
    height: 467,
    viewBox: "0 0 587 467",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_416_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.555 74.037L554.802 110.78C571.295 112.357 583.387 127.006 581.81 143.499L554.205 432.182C552.628 448.676 537.979 460.768 521.486 459.19L137.239 422.448C120.745 420.871 108.653 406.222 110.231 389.728L137.835 101.045C139.412 84.5518 154.061 72.4598 170.555 74.037Z",
    fill: "#303030",
    stroke: "#555555",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.17 128.918L579.145 171.372L554.301 431.187C552.723 447.68 538.074 459.772 521.581 458.195L137.334 421.452C120.841 419.875 108.749 405.226 110.326 388.733L135.17 128.918Z",
    fill: "#303030",
    stroke: "#555555",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 168.98,
    cy: 101.01,
    r: 9,
    transform: "rotate(5.46217 168.98 101.01)",
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.744,
    cy: 105.959,
    r: 9,
    transform: "rotate(5.46217 220.744 105.959)",
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.862,
    cy: 103.484,
    r: 9,
    transform: "rotate(5.46217 194.862 103.484)",
    fill: "#FFBD44"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 349.447,
    cy: 230.777,
    r: 36,
    transform: "rotate(5.46217 349.447 230.777)",
    fill: "#D9D9D9"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_416_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.637 229.827C354.87 230.327 359.517 226.491 360.018 221.258C360.518 216.025 356.682 211.378 351.449 210.877C346.216 210.377 341.569 214.213 341.068 219.446C340.568 224.679 344.404 229.326 349.637 229.827Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.841 250.499C364.983 246.565 362.897 243.006 359.885 240.334C356.872 237.663 353.09 236.017 349.082 235.633C345.074 235.25 341.048 236.15 337.584 238.202C334.12 240.254 331.398 243.354 329.809 247.053L365.841 250.499Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_416_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.2439 16.5868L480.009 3.11563C496.567 2.53739 510.459 15.4919 511.037 32.0504L521.158 321.874C521.737 338.432 508.782 352.324 492.224 352.902L106.459 366.374C89.9003 366.952 76.0083 353.997 75.43 337.439L65.3092 47.6155C64.7309 31.0571 77.6855 17.1651 94.2439 16.5868Z",
    fill: "#303030",
    stroke: "#555555",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2864 75.5985L512.015 60.0334L521.123 320.874C521.702 337.433 508.747 351.325 492.189 351.903L106.424 365.374C89.8654 365.953 75.9734 352.998 75.3951 336.44L66.2864 75.5985Z",
    fill: "#303030",
    stroke: "#555555",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.1856,
    cy: 43.5355,
    r: 9,
    transform: "rotate(-2 96.1856 43.5355)",
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.154,
    cy: 41.7207,
    r: 9,
    transform: "rotate(-2 148.154 41.7207)",
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.17,
    cy: 42.6282,
    r: 9,
    transform: "rotate(-2 122.17 42.6282)",
    fill: "#FFBD44"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 180.28,
    y: 216.706,
    width: 228,
    height: 19,
    rx: 6,
    transform: "rotate(-2 180.28 216.706)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.977,
    cy: 148.767,
    r: 36,
    transform: "rotate(-2 291.977 148.767)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 155.553,
    y: 253.592,
    width: 288,
    height: 19,
    rx: 6,
    transform: "rotate(-2 155.553 253.592)",
    fill: "#EBEBEB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 167.767,
    y: 288.186,
    width: 258,
    height: 19,
    rx: 6,
    transform: "rotate(-2 167.767 288.186)",
    fill: "#EBEBEB"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_416_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.042 147.799C297.295 147.616 301.405 143.209 301.222 137.955C301.039 132.702 296.631 128.592 291.378 128.775C286.124 128.959 282.014 133.366 282.198 138.619C282.381 143.873 286.789 147.983 292.042 147.799Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.794 166.192C309.432 162.403 306.901 159.145 303.568 156.887C300.234 154.629 296.27 153.488 292.246 153.629C288.222 153.77 284.347 155.184 281.179 157.669C278.011 160.154 275.714 163.581 274.619 167.455L310.794 166.192Z",
    fill: "white",
    stroke: "#D0D0D0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_416_329)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.15075,
    y: 114.036,
    width: 446,
    height: 350,
    rx: 30,
    transform: "rotate(-4.5 2.15075 114.036)",
    fill: "#303030",
    stroke: "#555555",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.70141 171.857L451.327 136.864L471.804 397.06C473.104 413.577 460.768 428.021 444.251 429.321L59.4405 459.606C42.923 460.906 28.4792 448.57 27.1792 432.052L6.70141 171.857Z",
    fill: "#303030",
    stroke: "#555555",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.1736,
    cy: 138.52,
    r: 9,
    transform: "rotate(-4.5 35.1736 138.52)",
    fill: "#FF605C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.0134,
    cy: 134.441,
    r: 9,
    transform: "rotate(-4.5 87.0134 134.441)",
    fill: "#00CA4E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.0934,
    cy: 136.48,
    r: 9,
    transform: "rotate(-4.5 61.0934 136.48)",
    fill: "#FFBD44"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-25-inside-1_416_329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.6277 190.798C35.281 186.393 38.5707 182.541 42.9753 182.195L135.432 174.918C139.837 174.571 143.688 177.861 144.035 182.266L153.842 306.88C154.189 311.285 150.899 315.137 146.495 315.483L54.0381 322.76C49.6334 323.107 45.7817 319.817 45.4351 315.412L35.6277 190.798Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6277 190.798C35.281 186.393 38.5707 182.541 42.9753 182.195L135.432 174.918C139.837 174.571 143.688 177.861 144.035 182.266L153.842 306.88C154.189 311.285 150.899 315.137 146.495 315.483L54.0381 322.76C49.6334 323.107 45.7817 319.817 45.4351 315.412L35.6277 190.798Z",
    fill: "#575757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.64 191.111C31.12 184.504 36.0545 178.727 42.6615 178.207L135.118 170.93C141.725 170.41 147.503 175.345 148.023 181.952L140.047 182.58C139.874 180.377 137.948 178.732 135.746 178.906L43.2892 186.182C41.0868 186.356 39.442 188.281 39.6153 190.484L31.64 191.111ZM157.83 306.567C158.35 313.174 153.416 318.951 146.809 319.471L54.3519 326.748C47.7449 327.268 41.9674 322.333 41.4474 315.726L49.4227 315.098C49.5961 317.301 51.5219 318.946 53.7242 318.772L146.181 311.496C148.383 311.322 150.028 309.397 149.855 307.194L157.83 306.567ZM54.3519 326.748C47.7449 327.268 41.9674 322.333 41.4474 315.726L31.64 191.111C31.12 184.504 36.0545 178.727 42.6615 178.207L43.2892 186.182C41.0868 186.356 39.442 188.281 39.6153 190.484L49.4227 315.098C49.5961 317.301 51.5219 318.946 53.7242 318.772L54.3519 326.748ZM135.118 170.93C141.725 170.41 147.503 175.345 148.023 181.952L157.83 306.567C158.35 313.174 153.416 318.951 146.809 319.471L146.181 311.496C148.383 311.322 150.028 309.397 149.855 307.194L140.047 182.58C139.874 180.377 137.948 178.732 135.746 178.906L135.118 170.93Z",
    fill: "#8B949E",
    mask: "url(#path-25-inside-1_416_329)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-2_416_329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.149 169.507C305.802 165.103 309.092 161.251 313.497 160.904L405.953 153.628C410.358 153.281 414.21 156.571 414.556 160.975L424.364 285.59C424.71 289.995 421.421 293.846 417.016 294.193L324.559 301.47C320.155 301.816 316.303 298.527 315.956 294.122L306.149 169.507Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306.149 169.507C305.802 165.103 309.092 161.251 313.497 160.904L405.953 153.628C410.358 153.281 414.21 156.571 414.556 160.975L424.364 285.59C424.71 289.995 421.421 293.846 417.016 294.193L324.559 301.47C320.155 301.816 316.303 298.527 315.956 294.122L306.149 169.507Z",
    fill: "#575757"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.161 169.821C301.641 163.214 306.576 157.436 313.183 156.917L405.639 149.64C412.246 149.12 418.024 154.055 418.544 160.662L410.569 161.289C410.395 159.087 408.469 157.442 406.267 157.615L313.81 164.892C311.608 165.065 309.963 166.991 310.137 169.193L302.161 169.821ZM428.351 285.276C428.871 291.883 423.937 297.661 417.33 298.181L324.873 305.457C318.266 305.977 312.489 301.043 311.969 294.436L319.944 293.808C320.117 296.01 322.043 297.655 324.245 297.482L416.702 290.205C418.904 290.032 420.549 288.106 420.376 285.904L428.351 285.276ZM324.873 305.457C318.266 305.977 312.489 301.043 311.969 294.436L302.161 169.821C301.641 163.214 306.576 157.436 313.183 156.917L313.81 164.892C311.608 165.065 309.963 166.991 310.137 169.193L319.944 293.808C320.117 296.01 322.043 297.655 324.245 297.482L324.873 305.457ZM405.639 149.64C412.246 149.12 418.024 154.055 418.544 160.662L428.351 285.276C428.871 291.883 423.937 297.661 417.33 298.181L416.702 290.205C418.904 290.032 420.549 288.106 420.376 285.904L410.569 161.289C410.395 159.087 408.469 157.442 406.267 157.615L405.639 149.64Z",
    fill: "#8B949E",
    mask: "url(#path-27-inside-2_416_329)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-29-inside-3_416_329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.888 180.152C170.542 175.748 173.831 171.896 178.236 171.549L270.693 164.273C275.097 163.926 278.949 167.216 279.296 171.62L285.415 249.38C285.762 253.785 282.472 257.636 278.068 257.983L185.611 265.26C181.206 265.606 177.355 262.317 177.008 257.912L170.888 180.152Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M170.888 180.152C170.542 175.748 173.831 171.896 178.236 171.549L270.693 164.273C275.097 163.926 278.949 167.216 279.296 171.62L285.415 249.38C285.762 253.785 282.472 257.636 278.068 257.983L185.611 265.26C181.206 265.606 177.355 262.317 177.008 257.912L170.888 180.152Z",
    fill: "#575757"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M166.901 180.466C166.381 173.859 171.315 168.082 177.922 167.562L270.379 160.285C276.986 159.765 282.763 164.7 283.283 171.307L275.308 171.934C275.135 169.732 273.209 168.087 271.006 168.26L178.55 175.537C176.347 175.71 174.703 177.636 174.876 179.839L166.901 180.466ZM289.403 249.066C289.923 255.673 284.989 261.451 278.382 261.971L185.925 269.247C179.318 269.767 173.54 264.833 173.02 258.226L180.996 257.598C181.169 259.8 183.095 261.445 185.297 261.272L277.754 253.995C279.956 253.822 281.601 251.896 281.428 249.694L289.403 249.066ZM185.925 269.247C179.318 269.767 173.54 264.833 173.02 258.226L166.901 180.466C166.381 173.859 171.315 168.082 177.922 167.562L178.55 175.537C176.347 175.71 174.703 177.636 174.876 179.839L180.996 257.598C181.169 259.8 183.095 261.445 185.297 261.272L185.925 269.247ZM270.379 160.285C276.986 159.765 282.763 164.7 283.283 171.307L289.403 249.066C289.923 255.673 284.989 261.451 278.382 261.971L277.754 253.995C279.956 253.822 281.601 251.896 281.428 249.694L275.308 171.934C275.135 169.732 273.209 168.087 271.006 168.26L270.379 160.285Z",
    fill: "#8B949E",
    mask: "url(#path-29-inside-3_416_329)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-4_416_329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8873 359.277C48.5407 354.872 51.8303 351.02 56.235 350.674L148.692 343.397C153.096 343.05 156.948 346.34 157.295 350.745L165.062 449.44L56.6548 457.971L48.8873 359.277Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8873 359.277C48.5407 354.872 51.8303 351.02 56.235 350.674L148.692 343.397C153.096 343.05 156.948 346.34 157.295 350.745L165.062 449.44L56.6548 457.971L48.8873 359.277Z",
    fill: "#575757"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8996 359.59C44.3797 352.983 49.3142 347.206 55.9211 346.686L148.378 339.409C154.985 338.889 160.762 343.824 161.282 350.431L153.307 351.059C153.134 348.856 151.208 347.211 149.006 347.385L56.5488 354.661C54.3465 354.835 52.7017 356.76 52.875 358.963L44.8996 359.59ZM165.062 449.44L56.6548 457.971L165.062 449.44ZM52.6671 458.285L44.8996 359.59C44.3797 352.983 49.3142 347.206 55.9211 346.686L56.5488 354.661C54.3465 354.835 52.7017 356.76 52.875 358.963L60.6424 457.658L52.6671 458.285ZM148.378 339.409C154.985 338.889 160.762 343.824 161.282 350.431L169.05 449.126L161.074 449.753L153.307 351.059C153.134 348.856 151.208 347.211 149.006 347.385L148.378 339.409Z",
    fill: "#8B949E",
    mask: "url(#path-31-inside-4_416_329)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-33-inside-5_416_329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.408 337.986C319.062 333.582 322.351 329.73 326.756 329.383L419.213 322.107C423.617 321.76 427.469 325.05 427.816 329.454L435.583 428.149L327.176 436.681L319.408 337.986Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M319.408 337.986C319.062 333.582 322.351 329.73 326.756 329.383L419.213 322.107C423.617 321.76 427.469 325.05 427.816 329.454L435.583 428.149L327.176 436.681L319.408 337.986Z",
    fill: "#575757"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M315.421 338.3C314.901 331.693 319.835 325.916 326.442 325.396L418.899 318.119C425.506 317.599 431.283 322.534 431.803 329.141L423.828 329.768C423.655 327.566 421.729 325.921 419.527 326.094L327.07 333.371C324.868 333.544 323.223 335.47 323.396 337.672L315.421 338.3ZM435.583 428.149L327.176 436.681L435.583 428.149ZM323.188 436.995L315.421 338.3C314.901 331.693 319.835 325.916 326.442 325.396L327.07 333.371C324.868 333.544 323.223 335.47 323.396 337.672L331.164 436.367L323.188 436.995ZM418.899 318.119C425.506 317.599 431.283 322.534 431.803 329.141L439.571 427.835L431.596 428.463L423.828 329.768C423.655 327.566 421.729 325.921 419.527 326.094L418.899 318.119Z",
    fill: "#8B949E",
    mask: "url(#path-33-inside-5_416_329)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-35-inside-6_416_329",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.46 301.776C180.114 297.372 183.403 293.52 187.808 293.173L280.265 285.897C284.669 285.55 288.521 288.84 288.868 293.244L300.323 438.794L191.915 447.326L180.46 301.776Z"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.46 301.776C180.114 297.372 183.403 293.52 187.808 293.173L280.265 285.897C284.669 285.55 288.521 288.84 288.868 293.244L300.323 438.794L191.915 447.326L180.46 301.776Z",
    fill: "#575757"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M176.473 302.09C175.953 295.483 180.887 289.706 187.494 289.186L279.951 281.909C286.558 281.389 292.335 286.324 292.855 292.931L284.88 293.558C284.707 291.356 282.781 289.711 280.579 289.884L188.122 297.161C185.919 297.334 184.275 299.26 184.448 301.462L176.473 302.09ZM300.323 438.794L191.915 447.326L300.323 438.794ZM187.928 447.64L176.473 302.09C175.953 295.483 180.887 289.706 187.494 289.186L188.122 297.161C185.919 297.334 184.275 299.26 184.448 301.462L195.903 447.012L187.928 447.64ZM279.951 281.909C286.558 281.389 292.335 286.324 292.855 292.931L304.31 438.48L296.335 439.108L284.88 293.558C284.707 291.356 282.781 289.711 280.579 289.884L279.951 281.909Z",
    fill: "#8B949E",
    mask: "url(#path-35-inside-6_416_329)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_416_329",
    x: 106.092,
    y: 71.8986,
    width: 479.856,
    height: 393.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_416_329",
    x: 61.2905,
    y: 1.09692,
    width: 463.886,
    height: 371.295,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_416_329",
    x: 0.4104,
    y: 79.3029,
    width: 475.567,
    height: 387.394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_416_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(330.446 208.869) rotate(5.46217)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_416_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white",
    transform: "translate(270.292 129.512) rotate(-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateDark);
export default __webpack_public_path__ + "static/media/empty_state_dark.0fde2e05f1615007a35908806f56dbcb.svg";
export { ForwardRef as ReactComponent };